module.exports = __webpack_public_path__ + "img/vk.39c31184.svg";